import { useState } from "react";
import { useTheme as useCustomTheme } from "./ThemeContext";
import {
  Paper,
  BottomNavigation,
  BottomNavigationAction,
  Menu,
  MenuItem,
  Box,
  Typography,
  Divider,
} from "@mui/material";
// import {
//   Dashboard,
//   Business,
//   ShoppingCart,
//   AccountBalance,
//   People,
//   BarChart,
//   Settings,
//   ChevronRight,
//   ArrowBack,
// } from "@mui/icons-material";
import {
  ChevronRight,
  ArrowBack,
  Dashboard,
  Business,
  ShoppingCart,
  AccountBalance,
  People,
  BarChart,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Settings,
  AccountTree,
  Inventory2,
  Savings,
  MoreHoriz,
  BalanceOutlined,
  CategoryOutlined,
  LabelOutlined,
  Assignment,
  LocalShipping,
  AssignmentReturn,
  Summarize,
  ReceiptLong,
  PersonSearch,
  ViewList,
  RequestQuote,
  ShoppingBag,
  Undo,
  BarChartOutlined,
  GroupWork,
  PeopleAlt,
  ListAlt,
  TableChart,
  MoveToInbox,
  Outbox,
  CompareArrows,
  Timeline,
  Receipt,
  PrecisionManufacturing,
} from "@mui/icons-material";

import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { useChat } from "./ChatContext";
import { Badge } from "@mui/material";

const MobileBottomNav = () => {
  const history = useHistory();
  const location = useLocation();
  const { appBarColor } = useCustomTheme();
  const { permissions } = useAuth();
  const { totalUnread } = useChat();
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);
  const [transactionSubMenu, setTransactionSubMenu] = useState(null); // 'purchase' or 'sales'
  const [productSubMenu, setProductSubMenu] = useState(false); // For Product submenu
  const [accountMasterSubMenu, setAccountMasterSubMenu] = useState(false); // For Account Master submenu
  const [masterSubMenu, setMasterSubMenu] = useState(false); // For Master (Client/Vendor) submenu
  const hasReadMasterPermission = permissions.includes('Read Master');
  const hasReadAccountsPermission = permissions.includes('Read Accounts');
  const hasReadAdministrationPermission = permissions.includes('Read Administration');
  const hasReadReportsPermission = permissions.includes('Read Reports');

  const handleMenuOpen = (event, menuId) => {
    setAnchorEl(event.currentTarget);
    setActiveMenu(menuId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setActiveMenu(null);
    setTransactionSubMenu(null);
    setProductSubMenu(false);
    setAccountMasterSubMenu(false);
    setMasterSubMenu(false);
  };

  const handleNavigation = (path) => {
    history.push(path);
    handleMenuClose();
  };

  const menuItems = {
    accountMaster: [
      { label: 'Account Head',  route: '/AccountHeadIndex',      icon: <AccountTree sx={{ fontSize: 15 }} /> },
      { label: 'Asset',         route: '/AssetIndex',            icon: <Inventory2 sx={{ fontSize: 15 }} /> },
      { label: 'Capital',       route: '/CapitalIndex',          icon: <Savings sx={{ fontSize: 15 }} /> },
      { label: 'Others',        route: '/OtherOptionIndex',      icon: <MoreHoriz sx={{ fontSize: 15 }} /> },
      { label: 'Sales Executive', route: '/SalesExecutiveIndex', icon: <PeopleAlt sx={{ fontSize: 15 }} /> },
      { label: 'Balance Sheet', route: '/BalanceSheetHeadIndex', icon: <BalanceOutlined sx={{ fontSize: 15 }} /> },
    ],
    master: [
      { label: 'Account Master', isNested: true, subMenuKey: 'accountMaster', icon: <AccountTree sx={{ fontSize: 15 }} /> },
      { label: 'Bank',           route: '/BankIndex',   icon: <AccountBalance sx={{ fontSize: 15 }} /> },
      { label: 'Company',        route: '/CompanyEdit', icon: <Business sx={{ fontSize: 15 }} /> },
      { label: 'Master',         isNested: true, subMenuKey: 'masterSub', icon: <People sx={{ fontSize: 15 }} /> },
      { label: 'Product',        isNested: true, subMenuKey: 'product',   icon: <Inventory2 sx={{ fontSize: 15 }} /> },
    ],
    masterSub: [
      { label: 'Client', route: '/ClientIndex', icon: <People sx={{ fontSize: 15 }} /> },
      { label: 'Vendor', route: '/VendorIndex', icon: <Business sx={{ fontSize: 15 }} /> },
    ],
    product: [
      { label: 'Category', route: '/ProductCategoryIndex', icon: <CategoryOutlined sx={{ fontSize: 15 }} /> },
      { label: 'Brand',    route: '/ProductBrandIndex',    icon: <LabelOutlined sx={{ fontSize: 15 }} /> },
      { label: 'Item',     route: '/ProductItemIndex',     icon: <Inventory2 sx={{ fontSize: 15 }} /> },
    ],
    transaction: {
      purchase: {
        entries: [
          { label: 'Purchase Order',  route: '/PurchaseOrderIndex',          icon: <Assignment sx={{ fontSize: 15 }} /> },
          { label: 'Purchase',        route: '/PurchaseIndex',               icon: <LocalShipping sx={{ fontSize: 15 }} /> },
          { label: 'Purchase Return', route: '/PurchaseReturnAgainstIndex',  icon: <AssignmentReturn sx={{ fontSize: 15 }} /> },
        ],
        reports: [
          { label: 'Purchase Report',          route: '/PurchaseReport',                   icon: <Summarize sx={{ fontSize: 15 }} /> },
          { label: 'PO Status Report',         route: '/PurchaseOrderStatusReport',        icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
          { label: 'Vendor & Item Wise',       route: '/VendorandItemWisePurchaseReport',  icon: <PersonSearch sx={{ fontSize: 15 }} /> },
          { label: 'Vendor Ageing',            route: '/VendorAgeingReport',               icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
          { label: 'Purchase Register',        route: '/PurchaseRegister',                 icon: <BarChart sx={{ fontSize: 15 }} /> },
        ],
      },
      sales: {
        entries: [
          { label: 'Quotation',    route: '/QuotationIndex',    icon: <RequestQuote sx={{ fontSize: 15 }} /> },
          { label: 'Sales Order',  route: '/SaleOrderIndex',    icon: <Assignment sx={{ fontSize: 15 }} /> },
          { label: 'Sales',        route: '/SaleIndex',         icon: <ShoppingBag sx={{ fontSize: 15 }} /> },
          { label: 'Sales Return', route: '/SalesReturnIndex',  icon: <Undo sx={{ fontSize: 15 }} /> },
        ],
        reports: [
          { label: 'Sales Report',           route: '/SalesReport',             icon: <Summarize sx={{ fontSize: 15 }} /> },
          { label: 'SO Status Report',       route: '/SalesOrderReport',        icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
          { label: 'Customer & Item Wise',   route: '/CustomerWiseSalesReport', icon: <PeopleAlt sx={{ fontSize: 15 }} /> },
          { label: 'Sales Register',         route: '/SalesRegister',           icon: <BarChart sx={{ fontSize: 15 }} /> },
        ],
      },
      stock: {
        entries: [
          { label: 'Stock Transfer In',  route: '/StockTransferInIndex',  icon: <MoveToInbox sx={{ fontSize: 15 }} /> },
          { label: 'Stock Transfer Out', route: '/StockTransferOutIndex', icon: <Outbox sx={{ fontSize: 15 }} /> },
        ],
        reports: [
          { label: 'Stock Transfer Report', route: '/StockTransferReport',  icon: <CompareArrows sx={{ fontSize: 15 }} /> },
          { label: 'Stock Movement Report', route: '/StockMovementReport',  icon: <Timeline sx={{ fontSize: 15 }} /> },
        ],
      },
      production: {
        entries: [
          { label: 'Production', route: '/ProductionIndex', icon: <PrecisionManufacturing sx={{ fontSize: 15 }} /> },
        ],
      },
    },
    einvoice: [
      { label: 'E-Invoice', route: '/EInvoiceIndex', icon: <Receipt sx={{ fontSize: 15 }} /> },
    ],
    accounts: [
      { label: 'Payment & Receipt', route: '/PaymentAndReceiptIndex', icon: <AccountBalance sx={{ fontSize: 15 }} /> },
      { label: 'Journal Entry',     route: '/JournalEntryIndex',      icon: <ReceiptLong sx={{ fontSize: 15 }} /> },
    ],
    reports: [
      { label: 'Ledger',           route: '/Ledger' },
      { label: 'CashBook',         route: '/CashBook' },
      { label: 'Sale GST Report',  route: '/SaleGstReport' },
      { label: 'Outstanding',      route: '/Outstanding' },
      { label: 'Expense Report',   route: '/ExpenseReport' },
    ],
    settings: [
      { label: 'Users',          route: '/UserIndex' },
      { label: 'Roles',          route: '/RoleIndex' },
      { label: 'Reset Password', route: '/PasswordChange' },
      { label: 'Theme Settings', route: '/ThemeSettings' },
    ],
  };

  // Helper to check if a route is active
  const isActive = (route) => location.pathname === route || location.pathname.startsWith(route + '/');
  const isAnyActive = (routes) => routes.some(r => isActive(r));

  const isMasterActive = isAnyActive([
    ...menuItems.master.filter(i => i.route).map(i => i.route),
    ...menuItems.masterSub.filter(i => i.route).map(i => i.route),
    ...menuItems.product.filter(i => i.route).map(i => i.route),
    ...menuItems.accountMaster.filter(i => i.route).map(i => i.route),
  ]);

  const isTransactionActive = isAnyActive([
    ...menuItems.transaction.purchase.entries.map(i => i.route),
    ...menuItems.transaction.purchase.reports.map(i => i.route),
    ...menuItems.transaction.sales.entries.map(i => i.route),
    ...menuItems.transaction.sales.reports.map(i => i.route),
    ...menuItems.transaction.stock.entries.map(i => i.route),
    ...menuItems.transaction.stock.reports.map(i => i.route),
    ...menuItems.transaction.production.entries.map(i => i.route),
    ...menuItems.einvoice.map(i => i.route),
  ]);

  const isAccountsActive = isAnyActive(menuItems.accounts.map(i => i.route));
  const isSettingsActive = isAnyActive(menuItems.settings.map(i => i.route));

  // Active style for menu items
  const activeItemSx = (route) => ({
    fontSize: '14px',
    py: 1.5,
    backgroundColor: isActive(route) ? 'rgba(255,215,0,0.2) !important' : 'transparent',
    borderLeft: isActive(route) ? '3px solid #FFD700' : '3px solid transparent',
    color: isActive(route) ? '#FFD700' : 'white',
    fontWeight: isActive(route) ? 700 : 400,
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' },
  });

  const activeSubItemSx = (route) => ({
    fontSize: '13px',
    py: 1.2,
    backgroundColor: isActive(route) ? 'rgba(255,215,0,0.2) !important' : 'transparent',
    borderLeft: isActive(route) ? '3px solid #FFD700' : '3px solid transparent',
    color: isActive(route) ? '#FFD700' : 'white',
    fontWeight: isActive(route) ? 700 : 400,
    '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' },
  });

  return (
    <>
      <Paper
        sx={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 1300,
          borderTop: '1px solid rgba(0,0,0,0.1)',
        }}
        elevation={8}
      >
        <BottomNavigation
          value={value}
          onChange={(event, newValue) => setValue(newValue)}
          sx={{
            backgroundColor: appBarColor,
            height: '60px',
            '& .MuiBottomNavigationAction-root': {
              color: 'rgba(255,255,255,0.6)',
              minWidth: '50px',
              padding: '6px 0',
              '&.Mui-selected': { color: '#fff' },
            },
            '& .MuiBottomNavigationAction-label': {
              fontSize: '10px', fontWeight: 500, marginTop: '2px',
            },
          }}
        >
          <BottomNavigationAction
            label="Home"
            icon={<Dashboard sx={{ fontSize: 22, color: isActive('/Home') ? '#FFD700' : 'inherit' }} />}
            onClick={() => history.push('/Home')}
            sx={{ borderTop: isActive('/Home') ? '2px solid #FFD700' : '2px solid transparent', color: isActive('/Home') ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
          />
          {hasReadMasterPermission && (
            <BottomNavigationAction
              label="Master"
              icon={<Business sx={{ fontSize: 22, color: isMasterActive ? '#FFD700' : 'inherit' }} />}
              onClick={(e) => handleMenuOpen(e, 'master')}
              sx={{ borderTop: isMasterActive ? '2px solid #FFD700' : '2px solid transparent', color: isMasterActive ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
            />
          )}
          {hasReadMasterPermission && (
            <BottomNavigationAction
              label="Transaction"
              icon={<ShoppingCart sx={{ fontSize: 22, color: isTransactionActive ? '#FFD700' : 'inherit' }} />}
              onClick={(e) => handleMenuOpen(e, 'transaction')}
              sx={{ borderTop: isTransactionActive ? '2px solid #FFD700' : '2px solid transparent', color: isTransactionActive ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
            />
          )}
          {hasReadAccountsPermission && (
            <BottomNavigationAction
              label="Accounts"
              icon={<AccountBalance sx={{ fontSize: 22, color: isAccountsActive ? '#FFD700' : 'inherit' }} />}
              onClick={(e) => handleMenuOpen(e, 'accounts')}
              sx={{ borderTop: isAccountsActive ? '2px solid #FFD700' : '2px solid transparent', color: isAccountsActive ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
            />
          )}
          {(hasReadReportsPermission || hasReadMasterPermission) && (
            <BottomNavigationAction
              label="Reports"
              icon={<BarChart sx={{ fontSize: 22, color: isActive('/ReportsHub') ? '#FFD700' : 'inherit' }} />}
              onClick={() => history.push('/ReportsHub')}
              sx={{ borderTop: isActive('/ReportsHub') ? '2px solid #FFD700' : '2px solid transparent', color: isActive('/ReportsHub') ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
            />
          )}
          <BottomNavigationAction
            label="Chat"
            icon={
              <Badge
                badgeContent={totalUnread > 0 ? (totalUnread > 99 ? '99+' : totalUnread) : null}
                sx={{ '& .MuiBadge-badge': { background: '#ef4444', color: '#fff', fontSize: 9, minWidth: 15, height: 15, padding: '0 3px' } }}
              >
                <span style={{ fontSize: 20, color: isActive('/InternalMessaging') ? '#FFD700' : 'inherit' }}>💬</span>
              </Badge>
            }
            onClick={() => history.push('/InternalMessaging')}
            sx={{ borderTop: isActive('/InternalMessaging') ? '2px solid #FFD700' : '2px solid transparent', color: isActive('/InternalMessaging') ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
          />
          <BottomNavigationAction
            label="More"
            icon={<Settings sx={{ fontSize: 22, color: isSettingsActive ? '#FFD700' : 'inherit' }} />}
            onClick={(e) => handleMenuOpen(e, 'settings')}
            sx={{ borderTop: isSettingsActive ? '2px solid #FFD700' : '2px solid transparent', color: isSettingsActive ? '#FFD700 !important' : 'rgba(255,255,255,0.6)' }}
          />
        </BottomNavigation>
      </Paper>

      {/* Master Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'master'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            backgroundColor: appBarColor,
            color: 'white',
            borderRadius: '12px',
            minWidth: '220px',
            maxHeight: '70vh',
            mb: 1,
          }
        }}
      >
        {!masterSubMenu ? (
          /* Main master list */
          menuItems.master.map((item, idx) => (
            <MenuItem
              key={idx}
              onClick={() => item.isNested ? setMasterSubMenu(item.subMenuKey) : handleNavigation(item.route)}
              sx={item.route ? {
                ...activeItemSx(item.route),
                display: 'flex', justifyContent: 'space-between',
              } : {
                fontSize: '14px', py: 1.5, color: 'white', display: 'flex', justifyContent: 'space-between',
                backgroundColor: item.subMenuKey && isAnyActive(menuItems[item.subMenuKey]?.map(s => s.route) || []) ? 'rgba(255,215,0,0.15) !important' : 'transparent',
                borderLeft: item.subMenuKey && isAnyActive(menuItems[item.subMenuKey]?.map(s => s.route) || []) ? '3px solid #FFD700' : '3px solid transparent',
                color: item.subMenuKey && isAnyActive(menuItems[item.subMenuKey]?.map(s => s.route) || []) ? '#FFD700' : 'white',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                {item.icon && <Box sx={{ display: 'flex', alignItems: 'center', opacity: 0.85 }}>{item.icon}</Box>}
                {item.label}
              </Box>
              {item.isNested && <ChevronRight sx={{ fontSize: 18 }} />}
            </MenuItem>
          ))
        ) : (
          /* Sub-menu */
          <>
            <MenuItem
              onClick={() => setMasterSubMenu(null)}
              sx={{ fontSize: '14px', py: 1, display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid rgba(255,255,255,0.2)', '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' } }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 600 }}>
                {masterSubMenu === 'accountMaster' ? 'Account Master' : masterSubMenu === 'masterSub' ? 'Master' : 'Product'}
              </span>
            </MenuItem>
            {(menuItems[masterSubMenu] || []).map((item, idx) => (
              <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={{ ...activeSubItemSx(item.route), display: 'flex', alignItems: 'center' }}>
                {item.icon && <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center', opacity: 0.85 }}>{item.icon}</Box>}
                {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>

      {/* Transaction Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'transaction'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            backgroundColor: appBarColor,
            color: 'white',
            borderRadius: '12px',
            minWidth: '220px',
            maxHeight: '70vh',
            mb: 1,
          }
        }}
      >
        {!transactionSubMenu ? (
          // Main transaction menu
          <>
            <MenuItem
              onClick={() => setTransactionSubMenu('purchase')}
              sx={{
                fontSize: '14px', py: 1.5, display: 'flex', justifyContent: 'space-between',
                backgroundColor: isAnyActive([...menuItems.transaction.purchase.entries.map(i => i.route), ...menuItems.transaction.purchase.reports.map(i => i.route)]) ? 'rgba(255,215,0,0.15) !important' : 'transparent',
                borderLeft: isAnyActive([...menuItems.transaction.purchase.entries.map(i => i.route), ...menuItems.transaction.purchase.reports.map(i => i.route)]) ? '3px solid #FFD700' : '3px solid transparent',
                color: isAnyActive([...menuItems.transaction.purchase.entries.map(i => i.route), ...menuItems.transaction.purchase.reports.map(i => i.route)]) ? '#FFD700' : 'white',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <LocalShipping sx={{ fontSize: 15, opacity: 0.85 }} />
                <span>Purchase</span>
              </Box>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
            <MenuItem
              onClick={() => setTransactionSubMenu('sales')}
              sx={{
                fontSize: '14px', py: 1.5, display: 'flex', justifyContent: 'space-between',
                backgroundColor: isAnyActive([...menuItems.transaction.sales.entries.map(i => i.route), ...menuItems.transaction.sales.reports.map(i => i.route)]) ? 'rgba(255,215,0,0.15) !important' : 'transparent',
                borderLeft: isAnyActive([...menuItems.transaction.sales.entries.map(i => i.route), ...menuItems.transaction.sales.reports.map(i => i.route)]) ? '3px solid #FFD700' : '3px solid transparent',
                color: isAnyActive([...menuItems.transaction.sales.entries.map(i => i.route), ...menuItems.transaction.sales.reports.map(i => i.route)]) ? '#FFD700' : 'white',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <ShoppingBag sx={{ fontSize: 15, opacity: 0.85 }} />
                <span>Sales</span>
              </Box>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
            <MenuItem
              onClick={() => setTransactionSubMenu('stock')}
              sx={{
                fontSize: '14px', py: 1.5, display: 'flex', justifyContent: 'space-between',
                backgroundColor: isAnyActive([...menuItems.transaction.stock.entries.map(i => i.route), ...menuItems.transaction.stock.reports.map(i => i.route)]) ? 'rgba(255,215,0,0.15) !important' : 'transparent',
                borderLeft: isAnyActive([...menuItems.transaction.stock.entries.map(i => i.route), ...menuItems.transaction.stock.reports.map(i => i.route)]) ? '3px solid #FFD700' : '3px solid transparent',
                color: isAnyActive([...menuItems.transaction.stock.entries.map(i => i.route), ...menuItems.transaction.stock.reports.map(i => i.route)]) ? '#FFD700' : 'white',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CompareArrows sx={{ fontSize: 15, opacity: 0.85 }} />
                <span>Stock</span>
              </Box>
              <ChevronRight sx={{ fontSize: 18 }} />
            </MenuItem>
            <MenuItem
              onClick={() => handleNavigation('/ProductionIndex')}
              sx={{
                fontSize: '14px', py: 1.5, display: 'flex', justifyContent: 'space-between',
                backgroundColor: isAnyActive(menuItems.transaction.production.entries.map(i => i.route)) ? 'rgba(255,215,0,0.15) !important' : 'transparent',
                borderLeft: isAnyActive(menuItems.transaction.production.entries.map(i => i.route)) ? '3px solid #FFD700' : '3px solid transparent',
                color: isAnyActive(menuItems.transaction.production.entries.map(i => i.route)) ? '#FFD700' : 'white',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1) !important' }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <PrecisionManufacturing sx={{ fontSize: 15, opacity: 0.85 }} />
                <span>Production</span>
              </Box>
            </MenuItem>
            <MenuItem
              onClick={() => handleNavigation('/EInvoiceIndex')}
              sx={activeItemSx('/EInvoiceIndex')}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Receipt sx={{ fontSize: 15, opacity: 0.85 }} />
                <span>E-Invoice</span>
              </Box>
            </MenuItem>
          </>
        ) : (
          // Sub-menu (Purchase or Sales)
          <>
            <MenuItem
              onClick={() => setTransactionSubMenu(null)}
              sx={{
                fontSize: '14px',
                py: 1,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                borderBottom: '1px solid rgba(255,255,255,0.2)',
                '&:hover': { backgroundColor: 'rgba(255,255,255,0.1)' }
              }}
            >
              <ArrowBack sx={{ fontSize: 18 }} />
              <span style={{ fontWeight: 600 }}>
                {transactionSubMenu === 'purchase' ? 'Purchase' : transactionSubMenu === 'sales' ? 'Sales' : transactionSubMenu === 'production' ? 'Production' : 'Stock'}
              </span>
            </MenuItem>
            {/* Entry items */}
            {menuItems.transaction[transactionSubMenu].entries.map((item, idx) => (
              <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeSubItemSx(item.route)}>
                {item.icon && <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center', opacity: 0.85 }}>{item.icon}</Box>}
                {item.label}
              </MenuItem>
            ))}
            {/* Reports header divider */}
            <Box sx={{ my: 0.5 }}>
              <Divider sx={{ borderColor: '#FFD700', borderWidth: '1px' }} />
              <Typography
                sx={{
                  color: '#FFD700',
                  px: 2,
                  py: 0.5,
                  fontSize: '11px',
                  fontWeight: 600,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}
              >
                Reports
              </Typography>
            </Box>
            {/* Report items */}
            {menuItems.transaction[transactionSubMenu].reports.map((item, idx) => (
              <MenuItem key={`report-${idx}`} onClick={() => handleNavigation(item.route)} sx={activeSubItemSx(item.route)}>
                {item.icon && <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center', opacity: 0.85 }}>{item.icon}</Box>}
                {item.label}
              </MenuItem>
            ))}
          </>
        )}
      </Menu>

      {/* Accounts Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'accounts'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            backgroundColor: appBarColor,
            color: 'white',
            borderRadius: '12px',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.accounts.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.icon && <Box sx={{ mr: 1.5, display: 'flex', alignItems: 'center', opacity: 0.85 }}>{item.icon}</Box>}
            {item.label}
          </MenuItem>
        ))}
      </Menu>

      {/* Settings Menu */}
      <Menu
        anchorEl={anchorEl}
        open={activeMenu === 'settings'}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        transformOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        PaperProps={{
          sx: {
            backgroundColor: appBarColor,
            color: 'white',
            borderRadius: '12px',
            minWidth: '180px',
            mb: 1,
          }
        }}
      >
        {menuItems.settings.map((item, idx) => (
          <MenuItem key={idx} onClick={() => handleNavigation(item.route)} sx={activeItemSx(item.route)}>
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default MobileBottomNav;
